export interface Location {
  href: string;
  pathname: string;
  hostname: string;
  search: string;
}

const locations: Location[] = [];

export const getLocations = () => {
  return locations;
};

export const getCurrentLocation = () => {
  if (locations.length > 0) {
    return locations[locations.length - 1];
  }

  return null;
};

export const pushToLocationService = (location: Location) => {
  const currentLocation = getCurrentLocation();

  // don't push the next locations on the stack if it's the same href as the current one you're on
  if (currentLocation && currentLocation.href === location.href) {
    return;
  }

  // limit the length of the array to 100 (which is arbitrarily chosen)
  if (locations.length >= 100) {
    locations.shift();
  }

  locations.push(location);
};

export const getPreviousLocation = () => {
  if (locations.length > 1) {
    return locations[locations.length - 2];
  }

  return null;
};
